import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Fourmreports*/
export const registerFourmreport = async (fourmreportData) => {
  try {
    const response = await api.post("/bnf/reports-four", fourmreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "fourmreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchFourmreportsFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, signal) => {
  try {
    const params = { page, per_page: perPage };
    if (search) params.search = search;
    
    // Add column-specific filters
    if (columnFilters.report_id) params.report_id = columnFilters.report_id;
    if (columnFilters.vendor_code) params.vendor_code = columnFilters.vendor_code;
    if (columnFilters.part_number) params.part_number = columnFilters.part_number;
    if (columnFilters.full_name) params.full_name = columnFilters.full_name;
    if (columnFilters.item_problem) params.item_problem = columnFilters.item_problem;
    
    const response = await api.get("/bnf/reports-four", {
      params: params,
      signal,
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "fourmreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};




export const downloadFileFromAPI = async (fileType, search) => {
  try {
    // Convert forecastMonth from "YYYY-MM" to "YYYYMM"
    // const formattedForecastMonth = forecastMonth.replace("-", "");

    const response = await api.post(`/bnf/4m/download/stock-report/${fileType}/${fileType}`, search);


    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;

      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }


  } catch (error) {

    
    const fallback = generateErrorMessage("download forecast file", "forecast");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteFourmreportsFromAPI = async (fourmreportId) => {
  try {
    const response = await api.delete(`/bnf/reports-four/${fourmreportId}`, {
      params: { fourmreport_id: fourmreportId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "fourmreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchFourmreportsById = async (fourmreportId) => {
  try {    
    const response = await api.get(`/bnf/reports-four/${fourmreportId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data fourmreport", "fourmreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateFourmreport = async (id, fourmreportData) => {
  try {
    const response = await api.put(`/bnf/reports-four/${id}`, fourmreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "fourmreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadFourmreportSummaryPDFFromAPI = async (search) => {
  try {
    const response = await api.post(`/bnf/4m-stock-summary`, search);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download 4M stock summary PDF", "4M stock summary");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const downloadFourmreportSummaryExcelFromAPI = async (search) => {
  try {
    const response = await api.post(`/bnf/4m-summary/excel`, search);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download 4M stock summary Excel", "4M stock summary");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


